module.exports = "\n  <h1>You have been logged out </h1>\n  <h2>Click <a href=\"/login\">here</a> to login again. </h2>\n\n"